module.exports = __webpack_public_path__ + "static/media/icons_top_right.7a022377.png";